document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-reserve-purchase-toggle]').forEach((wrap) => {
    const options = wrap.querySelectorAll('[data-reserve-option]');
    const radios = wrap.querySelectorAll('[data-reserve-radio]');
    const sellingPlanInput = wrap.querySelector('[data-reserve-selling-plan-input]');

    options.forEach((option) => {
      const radio = option.querySelector('[data-reserve-radio]');
      if (!radio) return;

      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        // The launch-pricing option lives outside the add-to-cart <form>
        // (forms can't nest), so it isn't in the same native radio
        // group as the in-form options — sync checked state by hand.
        radios.forEach((other) => {
          other.checked = other === radio;
        });
        options.forEach((other) => other.classList.toggle('is-selected', other === option));

        if (sellingPlanInput) {
          const plan = option.dataset.plan || '';
          sellingPlanInput.value = plan;
          sellingPlanInput.disabled = plan === '';
        }
      });
    });
  });

  document.querySelectorAll('[data-reserve-gallery]').forEach((galleryMain) => {
    const media = galleryMain.closest('.reserve-purchase__media');
    if (!media) return;

    const mainImages = galleryMain.querySelectorAll('.reserve-purchase__media-image');
    const thumbs = media.querySelectorAll('[data-gallery-thumb]');
    const prevButton = media.querySelector('[data-gallery-prev]');
    const nextButton = media.querySelector('[data-gallery-next]');
    const count = mainImages.length;
    if (count < 2) return;

    let currentIndex = 0;

    const goToIndex = (index) => {
      currentIndex = (index + count) % count;
      mainImages.forEach((img, i) => img.classList.toggle('is-active', i === currentIndex));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === currentIndex));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goToIndex(Number(thumb.dataset.index)));
    });

    if (prevButton) prevButton.addEventListener('click', () => goToIndex(currentIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => goToIndex(currentIndex + 1));
  });
});
